import type { accountReservationRevRec_enum } from '@vrplatform/graphql';

export const getRevenueRecognitionLabel = (
  value: accountReservationRevRec_enum | null | undefined
) => {
  if (value === 'checkIn') return 'Check-in';
  if (value === 'checkOut') return 'Check-out';
  if (value === 'bookedAt') return 'Booked At';
  if (value === 'proRata') return 'Pro Rata';

  return null;
};

export const getPostingDatePlaceholder = (
  value: accountReservationRevRec_enum | null | undefined
) => {
  const revenueRecognitionLabel = getRevenueRecognitionLabel(value);

  return revenueRecognitionLabel
    ? `Default: ${revenueRecognitionLabel}`
    : 'Select posting date';
};
